import { stdObject } from "../../../../data/types/stdObject";

export const createCommision = ({
  id,
  name,
  group,
  itemCode,
  item,
  data,
  docValues,
}: {
  id: number;
  name: string;
  group: number;
  itemCode: string;
  item: stdObject | false;
  data: stdObject;
  docValues: stdObject;
}) => {
  if (!item) return false;

  let BASCOY: number | undefined = undefined;
  let PROCOY: number | undefined = undefined;
  [
    [0, itemCode, "AGECOZ", Number(id)],
    [0, itemCode, "GRUCOZ", Number(group)],
    [1, item.FAMART, "AGECOZ", Number(id)],
    [1, item.FAMART, "GRUCOZ", Number(group)],
  ].forEach((e) => {
    if (!PROCOY) {
      const itemComm = item.COMMART.find(
        (v: stdObject) =>
          v.TIPCOZ === e[0] && v.ARTCOZ === e[1] && v[e[2]] === e[3],
      );
      BASCOY = itemComm?.BASCOZ;
      PROCOY = itemComm?.PORCOZ;
    }
  });
  return data[`PRE${docValues.itemType}`] !== 0 && PROCOY
    ? {
        DOCCOY: docValues.type,
        SERCOY: docValues.data[`SER${docValues.type}`].value,
        CODCOY: docValues.data[`COD${docValues.type}`].value,
        LINCOY: data[`LIN${docValues.itemType}`],
        CANCOY: data[`CAN${docValues.itemType}`],
        ARTCOY: data[`ART${docValues.itemType}`],
        NOMCOY: data[`NOM${docValues.itemType}`],
        GRUCOY: group,
        AGECOY: id,
        ANOCOY: name,
        BASCOY,
        PROCOY,
        PRECOY: BASCOY
          ? Number(
              (
                data[`PRE${docValues.itemType}`] -
                data[`PCO${docValues.itemType}`]
              ).toFixed(2),
            )
          : data[`PRE${docValues.itemType}`],
        PAGCOY: 0,
      }
    : false;
};
